import * as tslib_1 from "tslib";
import getTimeZone from '../services/getTimeZone';
import setSupportedTimeZones from '../data/mutators/setSupportedTimeZones';
export default function loadTimeZoneOptions() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getTimeZone().then(function (timeZones) {
                        setSupportedTimeZones(timeZones);
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=loadTimeZoneOptions.js.map